import { useFirstOrderIncentiveStore } from "@faire/retailer-visitor-shared/hooks/firstOrderIncentive/useFirstOrderIncentiveStore";
import { useAutoExtendText } from "./useAutoExtendText";
import { useGenericText } from "./useGenericText";
import { useVerticalizedFOITopBannerText } from "./useVerticalizedFOITopBannerText";
export var useBannerText = function() {
    var _useFirstOrderIncentiveStore = useFirstOrderIncentiveStore(), isFirstOrderIncentiveAutoExtendEnabled = _useFirstOrderIncentiveStore.isFirstOrderIncentiveAutoExtendEnabled, isLastChanceIncentive = _useFirstOrderIncentiveStore.isLastChanceIncentive;
    var genericText = useGenericText();
    var autoExtendText = useAutoExtendText();
    var verticalizedText = useVerticalizedFOITopBannerText();
    var bannerText = function() {
        switch(true){
            case isFirstOrderIncentiveAutoExtendEnabled:
                return autoExtendText;
            case isLastChanceIncentive:
                return verticalizedText;
            default:
                return genericText;
        }
    };
    return bannerText();
};
